import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "driver.js/dist/driver.css";
import "./tutorials/tourTheme.css";
import App from './App';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { store } from "./store/store";
import { PostHogProvider } from 'posthog-js/react';
import { cleanupIndexedDB } from './utils/indexedDBCleanup';

// Clean up any existing IndexedDB data on app initialization
cleanupIndexedDB();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
      }}
    >
      <Provider store={store}>
        <App />
      </Provider>
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();